(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('calendar', {
            parent: 'app',
            url: '/calendar',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/calendar/calendar.html',
                    controller: 'CalendarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('calendar');
                    return $translate.refresh();
                }]
            }
        })
        ;
        
        
    }
})();
